import { useGetControlsControlIdSuspense } from "api/generated/controls/controls";

import { CONTROL_QUERY_KEY } from "../../queries/useControlQuery";

export const useControlSuspenseQuery = (controlId: string) =>
    useGetControlsControlIdSuspense(controlId, {
        query: {
            queryKey: [CONTROL_QUERY_KEY, controlId],
            select: (response) => response.data,
        },
    });
